import { getDefaultExportFromCjs as p } from "./_commonjsHelpers.mjs";
import { __module as d } from "./index338.mjs";
(function(P, a) {
  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;
  function i(t, e) {
    switch (t) {
      case "P":
        return e.date({
          width: "short"
        });
      case "PP":
        return e.date({
          width: "medium"
        });
      case "PPP":
        return e.date({
          width: "long"
        });
      case "PPPP":
      default:
        return e.date({
          width: "full"
        });
    }
  }
  function u(t, e) {
    switch (t) {
      case "p":
        return e.time({
          width: "short"
        });
      case "pp":
        return e.time({
          width: "medium"
        });
      case "ppp":
        return e.time({
          width: "long"
        });
      case "pppp":
      default:
        return e.time({
          width: "full"
        });
    }
  }
  function m(t, e) {
    var s = t.match(/(P+)(p+)?/) || [], l = s[1], c = s[2];
    if (!c)
      return i(t, e);
    var r;
    switch (l) {
      case "P":
        r = e.dateTime({
          width: "short"
        });
        break;
      case "PP":
        r = e.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        r = e.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        r = e.dateTime({
          width: "full"
        });
        break;
    }
    return r.replace("{{date}}", i(l, e)).replace("{{time}}", u(c, e));
  }
  var h = {
    p: u,
    P: m
  }, n = h;
  a.default = n, P.exports = a.default;
})(d, d.exports);
var w = d.exports;
const F = /* @__PURE__ */ p(w);
export {
  F as default
};
//# sourceMappingURL=index291.mjs.map
